<app-header></app-header>
<app-alert-resumo-importacao [alertResumoImportacao]="showAlertResumoImportacao" [resumoImportacao]="dadosResumoImportacao" (alertResumoImportacaoFechou)="eventoAlertResumoImportacao($event)" sourceScreen="tratativas:resumo-de-importacao" screenType="pagina"></app-alert-resumo-importacao>
<app-alert-sucesso [alertSucesso]="showAlertSucesso" [alertSucessoSubtitulo]="tituloAlertSucesso" [alertSucessoMensagem]="substituloAlertSucesso" (alertSucessoFechou)="eventoAlertSucesso($event)" (alertSucessoAvancou)="alertSucessoAvancou()"></app-alert-sucesso>
<app-botao-chat></app-botao-chat>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-alert-erro [alertErro]="showAlertErro" [botao2]="botao2" [mensagemErro]="mensagemErroApi" (alertErroFechou)="eventoAlertErro($event)"></app-alert-erro>


<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Tratativas</h1>
        <p class="paragrafo mb-4">Realize a tratativa de endereços e/ou produtos</p>

        <!-- ABAS NAVEGAÇÃO -->
        <ul class="nav nav-tabs border-0" id="myTab">
          <li class="nav-item me-4">
            <a class="nav-link active" id="endereco-tab" data-bs-toggle="tab" href="#endereco"
              aria-controls="endereco"
              (click)="addTagInPageChange('manutencao-de-endereco', 'tratativas', 'tratativas', 'pagina')">
              Manutenção de Endereço
              @if (qtdeInconsistenciasEnderecos) {
                <span class="badge text-bg-danger">
                  {{ qtdeInconsistenciasEnderecos }}
                </span>
              }
            </a>
          </li>
          @if (qtdeInconsistenciasEnderecos == 0) {
            <li class="nav-item me-4">
              <a class="nav-link" id="produto-tab" data-bs-toggle="tab" href="#produto"
                aria-controls="produto"
                (click)="addTagInPageChange('manutencao-de-produto', 'tratativas', 'tratativas', 'pagina')">
                Manutenção de Produto
                @if (qtdeInconsistenciasProdutos) {
                  <span class="badge text-bg-danger">
                    {{ qtdeInconsistenciasProdutos }}
                  </span>
                }
              </a>
            </li>
          }
          <!-- Esse é o link que fica desativado quando o usuário não pode ir pra outra aba, só esse -->
          @if (qtdeInconsistenciasEnderecos != '0') {
            <li class="nav-item me-4"
              data-bs-toggle="tooltip"
              data-placement="top"
              title="Resolva as inconsistências de endereço primeiro">
              <a disabled class="nav-link desabilitado">
                Manutenção de Produto
                @if (qtdeInconsistenciasProdutos) {
                  <span class="badge text-bg-danger">
                    {{ qtdeInconsistenciasProdutos }}
                  </span>
                }
              </a>
            </li>
          }
        </ul>
        <div class="tab-content" id="myTabContent">
          <!-- CONTEÚDO DA ABA DE ENDEREÇO -->
          <div class="tab-pane fade show active" id="endereco" role="tabpanel" aria-labelledby="endereco-tab">
            <app-tratativas-enderecos></app-tratativas-enderecos>
          </div>
          <!-- CONTEÚDO DA ABA DE PRODUTO -->
          <div class="tab-pane fade" id="produto" role="tabpanel" aria-labelledby="produto-tab">
            <app-tratativas-produtos></app-tratativas-produtos>
          </div>
        </div>
        <div class="w-100 text-center mt-4">
          @if (qtdeInconsistenciasEnderecos != 0 && qtdeInconsistenciasProdutos == 0) {
            <button class="botao-ir-resumo disabled" data-bs-toggle="tooltip" data-placement="top" title="Resolvas as inconsistências de endereço primeiro, em seguida resolva as de produtos ou ignore-as.">IR PARA RESUMO</button>
          }
          @if (qtdeInconsistenciasEnderecos == 0 && qtdeInconsistenciasProdutos != 0) {
            <button class="botao-ir-resumo disabled" data-bs-toggle="tooltip" data-placement="top" title="Resolvas as inconsistências de endereço primeiro, em seguida resolva as de produtos ou ignore-as.">IR PARA RESUMO</button>
          }
          @if (qtdeInconsistenciasEnderecos != 0 && qtdeInconsistenciasProdutos != 0) {
            <button class="botao-ir-resumo disabled" data-bs-toggle="tooltip" data-placement="top" title="Resolvas as inconsistências de endereço primeiro, em seguida resolva as de produtos ou ignore-as.">IR PARA RESUMO</button>
          }
          @if (qtdeInconsistenciasEnderecos == 0 && qtdeInconsistenciasProdutos == 0) {
            <button class="botao-ir-resumo" (click)="preConclusaoImportacao()">IR PARA RESUMO</button>
          }
          <button class="botao-outline ms-4 ajuste-botao" (click)="cancelarImportacao()">CANCELAR IMPORTAÇÃO</button>
        </div>

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
